import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'
import 'fontsource-roboto';

import './reset.css'

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

